import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureCTAProps {
  title: string;
  description: string;
  primaryCTA: {
    text: string;
    link: string;
  };
  secondaryCTA?: {
    text: string;
    link: string;
  };
}

export function FeatureCTA({ title, description, primaryCTA, secondaryCTA }: FeatureCTAProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary via-grow to-secondary p-12 shadow-2xl">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white/10 rounded-full blur-2xl" />
      <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-32 h-32 bg-white/10 rounded-full blur-2xl" />

      <div className="relative z-10 text-center max-w-3xl mx-auto">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm mb-6">
          <Sparkles className="h-8 w-8 text-white" />
        </div>

        <h2 className="text-3xl font-bold text-white mb-4">
          {title}
        </h2>
        <p className="text-lg text-white/90 mb-8">
          {description}
        </p>

        <div className="flex items-center justify-center gap-4">
          <Button asChild size="lg" variant="secondary" className="group">
            <Link to={primaryCTA.link}>
              {primaryCTA.text}
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>

          {secondaryCTA && (
            <Button asChild size="lg" variant="outline" className="bg-white/10 border-white/20 text-white hover:bg-white/20 hover:text-white">
              <Link to={secondaryCTA.link}>
                {secondaryCTA.text}
              </Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
